module.exports = __webpack_public_path__ + "img/user_structure_company.7258dcd1.svg";